var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhaseIconTotal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.56 184.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#359f8f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 184.56,
    height: 184.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.28,
    width: 184,
    height: 184
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.14,113.91H85.8v11.33H45.4V64.1H60.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.07,117.68a23.75,23.75,0,0,1-9.95,6.09,43,43,0,0,1-14.36,2.31q-12,0-19.19-7.35T90.88,98.28l0-5.29A36.4,36.4,0,0,1,94,77.23a23.74,23.74,0,0,1,9.13-10.38,25.86,25.86,0,0,1,13.76-3.63q11.42,0,17.74,5.23T142,84.05h-14.2c-.5-3.42-1.59-5.85-3.27-7.31s-4.06-2.18-7.14-2.18a9.63,9.63,0,0,0-8.57,4.7q-3,4.71-3.06,13.44v3.69q0,9.17,3.13,13.76t9.84,4.6c3.84,0,6.69-.86,8.57-2.57v-9.49H117.08V92.57h25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.16,33.37h0a5,5,0,0,1-5-5V0h9.93l0,28.4A5,5,0,0,1,132.16,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.66,33.37h0a5,5,0,0,1-5-5V0h9.93l0,28.4A5,5,0,0,1,150.66,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.16,33.37h0a5,5,0,0,1-5-5V0h9.93l0,28.4A5,5,0,0,1,169.16,33.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIconTotal);
export default __webpack_public_path__ + "static/media/PhaseIconTotal.8aa0dba1ab0efb2b4514d4d61930b3ed.svg";
export { ForwardRef as ReactComponent };